import { defineMessages } from 'react-intl';

export default defineMessages({
    totalInterest: {
        id: '_.draw_down.choose_amount.total_interest',
        defaultMessage: 'Total interest'
    }
});
